<div class="flex my-2.5 mx-7 flex-col flex-1">
  <form class="flex flex-col h-full" #generalForm="ngForm" role="form">
    <app-input-upload
      [files]="model?.files"
      label="Drag or click to upload files"
      placeholder="Drag or click to upload files"
      (filesChanged)="filesChanged($event)"
      (removeFile)="removeFile($event)"
      [allowMultipleFiles]="true"
    >
    </app-input-upload>

    <div class="flex gap-4">
      <app-floating-input
        [(ngModel)]="model.number"
        (ngModelChange)="numberChanged($event)"
        label="PCCO Number"
        placeholder="PCCO Number"
        name="number"
        required
        [minLength]="1"
        [maxLength]="10"
        [disabled]="customIdDisabled"
        patternErrorMessage="Already taken"
        [iconClass]="customIdDisabled ? 'icon-text-edit' : 'icon-text-revert'"
        (iconClick)="onCustomIdIconClick()"
        class="w-full"
      ></app-floating-input>

      <app-floating-input
        class="w-full"
        required
        [(ngModel)]="model.title"
        name="title"
        label="Title"
        placeholder="Title"
      ></app-floating-input>
    </div>

    <div class="flex gap-4">
      <app-input-calendar
        required
        [minStartDate]="(project$ | async)?.start_date"
        [(date)]="model.date"
        class="w-full"
        name="date"
        placeholder="Date"
      ></app-input-calendar>

      <app-dropdown
        required
        [optionLabel]="null"
        [optionValue]="null"
        [required]="true"
        placeholder="Status"
        label="Status"
        id="status"
        name="status"
        [(ngModel)]="model.status"
        [options]="statuses"
        class="w-full"
      >
        <ng-template #selectedContent #optionContent let-option>
          <div class="capitalize text-navy-900 text-medium">{{ option }}</div>
        </ng-template>
      </app-dropdown>
    </div>

    <label class="flex gap-1 text-navy-600 text-xs mt-2 ml-1 mb-0.5">
      <span class="font-semibold">Description</span>
      <span class="font-normal">(optional)</span>
    </label>
    <div (click)="textAreaElement.focus()" class="textarea-wrapper cursor-text">
      <textarea
        class="flex"
        #textAreaElement
        cdkTextareaAutosize
        name="note"
        [(ngModel)]="model.description"
      ></textarea>
    </div>
  </form>
</div>
